import React from 'react'

// CSS ring spinner coloured by the brand token (--color-brand-green), so the
// loader matches the operator's white-label colour when branded and falls back
// to the default brand green otherwise. Replaces the fixed-green loader.gif.
const FullPageLoader = () => {
  return (
    <div
      className="fixed w-full h-full top-0 left-0 bg-[#f8f8f8ad] z-999 flex justify-center items-center"
    >
      <div
        className="animate-spin rounded-full"
        style={{
          width: 56,
          height: 56,
          border: '5px solid color-mix(in srgb, var(--color-brand-green) 22%, transparent)',
          borderTopColor: 'var(--color-brand-green)',
        }}
      />
    </div>
  )
}

export default FullPageLoader;
